/**
 * Created by Ning Jiang on 11/17/2016.
 */
import {MotionPathPlugin} from "gsap/dist/MotionPathPlugin";

import ("pixi.js");
declare global {
    interface Window {
        PIXI: any;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require("pixi-spine");

import {gsap} from "gsap";
import {CustomEase} from "gsap/dist/CustomEase";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {CustomBounce} from "gsap/dist/CustomBounce";
gsap.registerPlugin(CustomEase, CustomWiggle,CustomBounce);
gsap.registerPlugin(MotionPathPlugin);

// gsap.globalTimeline.timeScale(5)

import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {DumpsterFire} from "./game/DumpsterFire";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {DumpsterFireIntroConfig} from "./game/intro/DumpsterFireIntroConfig";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DFPromoPanelConfig} from "./DFPromoPanelConfig";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-keypad/bin/core/app/gameintro/NolimitGameIntroPlugin";

declare global {
    interface Window {
        NolimitLauncher: NolimitLauncher;
    }
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.settings.log = LogLevel.DEV;
NolimitLauncher.instance.launch([
    new NolimitApplication(),
    new DumpsterFire(),
    new SlotKeypad(),
    new NolimitGameIntroPlugin(new DumpsterFireIntroConfig()),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new DFPromoPanelConfig())
]);
